const auth = {
  state: {
    auth: {
      refreshingState: false,
      refreshingCall: undefined,
      lastRefreshSuccess: true,
    }
  },

  mutations: {
    setRefreshingState(state, val) {
      state.auth.refreshingState = val;
    },
    setRefreshingCall(state, val) {
      state.auth.refreshingCall = val;
    },
    setLastRefreshSuccess(state, val) {
      state.auth.lastRefreshSuccess = val;
    }
  },
  namespaced: true
};

export default auth;
